import Vue from 'vue'
import VueRouter from 'vue-router'
import { getItem } from "@/utils";
import config from '@/config'
Vue.use(VueRouter)

const router = new VueRouter({
	routes: [
		{
			path: '/',
			component: () => import('@/views/Home/Index.vue')
		},
		{
			path: '/login',
			name: 'Login',
			component: () => import('@/views/Login/Index.vue')
		}
	]
})

const whiteList = ['/login']
router.beforeEach((to, form, next) => {
	if (whiteList.includes(to.path)) return next()
	const token = getItem(config.tokenName)
	if (!token) {
		const path = to.fullPath
		return next(`/login?path=${encodeURIComponent(path)}`)
	}
	next()
})


export default router
